import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { DictionarySelectBox } from "components/DictionaryTypeSelect/DictionaryTypeSelect";
import { ICON_TYPE, INVENTORYANDSALES_URL } from "utils/constants";
import { ENDPOINTSINVENTORYANDSALES } from "utils/endpoints";
import { Textbox } from "components/Textbox/Textbox";
import { Button } from "components/Button/Button";
import { WarehouseDictionaryWithAccess } from "pages/InventoryAndSales/Sales/SalesInvoice/components/WarehouseDictionary/WarehouseDictionaryWithAccess";


interface WarehouseData {
  WarehouseId?: string;
  WarehouseTitle?: string;
  WarehouseDetailsCount?: number;
  WarehouseDetailId?: string;
  WarehouseDetail?: string;
}

interface ItemData {
  Code?: string;
  Item?: string;
}

interface DetailPriceData {
  ItemTechnicalCode: string;
  Price: number;
  Discount: number;
  SubTotalPrice: number;
  Qty1: number;
  Qty2: number;
  TaxRate: number;
}

interface Props {
  mode: "view" | "edit" | 'create'; // You can change the mode types if necessary
  resetForm:any;
  setWarehouseData: (e) => void;
  setDetailPriceData: (e) => void;
  fetchPriceListDetail: (e ?:any,i?:any,wId?:any,WdId?:any) => void;
  setUserChanges: (e) => void;
  setShowTree: (e) => void;
  setItemData: (e) => void;
  warehouseData:any;
  detailPriceData:any;
  itemData:any;
  setPriceListDetail?:any
  setItemSearch?:any
  showTree?:any
}

const ItemSelector: React.FC<Props> = ({setItemData,showTree,setItemSearch,setDetailPriceData,setPriceListDetail,detailPriceData, itemData,mode, resetForm ,setWarehouseData ,warehouseData  ,fetchPriceListDetail ,setUserChanges ,setShowTree}) => {





  return (
         <div className="row">
             {  (warehouseData?.WarehouseId || mode=='create' )&& <>     <div className="col-lg-2 col-11">
                      <WarehouseDictionaryWithAccess
                        name="Warehouse"
                        WarehouseDetailId={warehouseData?.WarehouseDetailId}
                        label="Warehouse"
                        resetForm={resetForm}
                        value={warehouseData?.WarehouseId}
                        valueString={mode=='view' && warehouseData.WarehouseTitle?warehouseData.WarehouseTitle:''}
                        onChange={(e, obj) => {
                          setWarehouseData({
                        //  ...(warehouseData? warehouseData:{}),
                            WarehouseId: e,
                            WarehouseTitle: obj?.Name?.Description,
                            WarehouseDetailsCount:
                            obj?.Name?.WarehouseDetailsCount,
                            WarehouseDetailId: obj?.Name?.WarehouseDetailsCount>0 ?warehouseData?.WarehouseDetailId?warehouseData?.WarehouseDetailId:null:null
                          });
                          if (e !== warehouseData?.WarehouseId) {
                          //  setItemData(null);
                            setUserChanges({});
                            setDetailPriceData({
                              Price: 0,
                              Discount: 0,
                              SubTotalPrice: 0,
                              Qty1: 1,
                              Qty2: 1,
                              TaxRate: 0,
                            });
                            if(itemData?.ItemId &&obj?.Name?.WarehouseDetailsCount ==0) 
                             { 
                              fetchPriceListDetail(itemData.ItemId,null,e,'noHaveWarehouseDetail')
                             }
              
                          }
                          }
                       
                        }
                        mode={mode}
                        required={true}
                      />
                    </div>
                    {(warehouseData?.WarehouseDetailsCount > 0 ||
                      warehouseData?.WarehouseDetailId) && (
                      <div className="col-lg-2 col-11">
                        <DictionarySelectBox
                          name="WarehouseDetail"
                          label="WarehouseDetail"
                          params={{ warehouseId: warehouseData.WarehouseId }}
                          onChange={(e, obj) => {
            
                            setWarehouseData((prev) => {
                              return {
                                ...prev,
                                WarehouseDetailId: e,
                                WarehouseDetail: obj?.Name,
                              };
                            });


                                              if (e !== warehouseData?.WarehouseDetailId) {
                           // setItemData(null);
                            setUserChanges({});
                            setDetailPriceData({
                              Price: 0,
                              Discount: 0,
                              SubTotalPrice: 0,
                              Qty1: 1,
                              Qty2: 1,
                              TaxRate: 0,
                            });
                            itemData?.ItemId && fetchPriceListDetail(itemData.ItemId,null,warehouseData?.WarehouseId,e)

                          }
                          }}
                          baseUrl={INVENTORYANDSALES_URL}
                          endPoint={
                            ENDPOINTSINVENTORYANDSALES.Inventory
                              .BaseInformationApi.WarehouseDetail.dictionary
                          }
                          value={warehouseData.WarehouseDetailId}
                          resetForm={resetForm}
                          mode={mode}
                        />
                      </div>
                    )}
                    </>
                    }
                    {warehouseData && (
                      <div
                        className="col-lg-3 col-sm-12"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          flexDirection: "row",
                        }}
                      >
                        <Textbox
                          required
                          onBlurHandler={(e) => {
                            if (e && e != itemData?.Code  && !showTree ) {
                              fetchPriceListDetail(null, e);
                            }
                          }} 
                          Change={setUserChanges}
                          onChange={(e) => {
                            if (
                              e?.target.value === null ||
                              e?.target.value === ""
                            ) {
                              setItemData({});
                            setItemSearch("");
                                  setDetailPriceData({
                              Price: 0,
                              Discount: 0,
                              SubTotalPrice: 0,
                              Qty1: 1,
                              Qty2: 1,
                              TaxRate: 0,
                            });

                            }else {
                          if (
                            // e.target.value != itemData?.Code &&
                            e.target.value.length > 2 )
                         if(isNaN(e.target.value) )    {
                           
                           setShowTree(true);
                         }
                            setItemSearch(e.target.value);
                          
                        }
                          }    
                        }
                          textboxName={"itemCode"}
                          textboxType="text"
                          resetForm={resetForm}
                          labelText={"itemCode"}
                          mode={mode}
                          value={itemData?.Code}
                          defaultValue={itemData?.Code}
                        />
                        {mode != "view" && (
                          <div style={{ marginTop: "4px", width: "10%" }}>
                            <Button
                              Icon={true}
                              value={
                                <button
                                  onClick={(e) => {console.log('sssss');
                                  ;setShowTree(true)}}
                                  type="button"
                                  className="checkButton d-flex align-items-center justify-content-center"
                                >
                                  {" "}
                                  <FontAwesomeIcon
                                    icon={[ICON_TYPE, "diagram-project"]}
                                    size="1x"
                                  />
                                </button>
                              }
                              btnType="primary"
                              onClick={(e) =>{ setShowTree(true);console.log('eeeee');}}
                            />
                          </div>
                        )}
                      </div>
                    )}
  
                    <div className="col-lg-3 col-11">
                      <Textbox
                        Change={
                          setUserChanges
                        }
                        withChangeDir={true}
                        textboxName="ItemDescription"
                        textboxType="text"
                        labelText="ItemDescription"
                        value={itemData?.Item}
                        defaultValue={itemData?.Item}
                        resetForm={resetForm}
                        mode={"view"}
                        required={false}
                      />
                    </div>
  
                    <div className="col-lg-2 col-11">
                      <Textbox
                        Change={setUserChanges}
                        textboxName="ItemTechnicalCode"
                        textboxType="text"
                        labelText="TechnicalCode"
                        value={detailPriceData.ItemTechnicalCode + ""}
                        defaultValue={detailPriceData?.ItemTechnicalCode}
                        resetForm={resetForm}
                        mode="view"
                        required={false}
                      />
                    </div>
                  </div>
  );
};

export default ItemSelector;
